// @ts-check
import { log } from '../../common/utils/logger';

let organization;

export function identify(account) {
  if (!account) {
    throw new Error('Account not initialized');
  }

  const {
    current_provider_organization_id: currentOrg,
    account_name: user,
    organizations = []
  } = account;

  // TODO: Add support for multiple providers
  const provider = 'github';

  const { provider_organization_name: userOrganization = '' } =
    organizations.find(org => org.provider_organization_id === currentOrg);

  const identity = `${provider}/${user}`;
  organization = `${provider}/${userOrganization}`;

  if (process.env.NODE_ENV === 'development') {
    log(`Identifying user %c${identity}`, 'jungleGreen');
  }
  window?.analytics?.identify(identity, { organizations });
}

export const events = {
  VISIT: 'gitstream-webapp-visit',
  LOGIN: 'gitstream-webapp-login',
  PLAYGROUND_RUN: 'gitstream-playground-run'
};

function trackEvent(eventName, properties = {}) {
  const baseProperties = {
    org: organization
  };

  const eventProperties = {
    ...baseProperties,
    ...properties
  };

  if (process.env.NODE_ENV === 'development') {
    log(`Tracking event %c${eventName}`, 'electricViolet', eventProperties);
  }

  window?.analytics?.track(eventName, eventProperties);
}

export const trackEvents = {
  login() {
    trackEvent(events.LOGIN);
  },
  visit(path = '') {
    // Skip if we don't know the user's identity
    // this happens on the initial page load
    if (!organization) {
      return;
    }

    const properties = {
      path
    };

    trackEvent(events.VISIT, properties);
  },
  playgroundRun(payload) {
    trackEvent(events.PLAYGROUND_RUN, payload);
  }
};
